/** 1.8.2 (D-1.8.2-3) — the house calendar's one read: GET /api/calendar?month=yyyy-MM. Nothing here writes. */
import { useQuery } from '@tanstack/react-query';
import type { HouseCalendarResponse } from '@shared/house-calendar';
import { apiFetch } from '@/lib/api';

export function useHouseCalendar(month: string) {
  return useQuery({
    queryKey: ['house-calendar', month],
    queryFn: () => apiFetch<HouseCalendarResponse>(`/api/calendar?month=${encodeURIComponent(month)}`),
    staleTime: 60_000,
  });
}
